import React from 'react';
import {
  arrayOf, bool, func, node, oneOfType, string
} from 'prop-types';
import classNames from 'classnames';

const Footer = (props) => {
  const {
    className,
    children,
    onTriggerClick,
    scrollToBottom,
    triggerFor,
    hideTopBorder,
    nopadding
  } = props;
  const classes = classNames(
    'content-card__footer',
    className,
    {
      'content-card__footer--no-top-border': hideTopBorder,
      'content-card__footer--no-padding': nopadding
    }
  );

  const trigger = (scrollToBottom && !triggerFor) ? 'default-overlay' : triggerFor;

  const triggerClick = (event) => {
    if (trigger) {
      onTriggerClick(event, trigger, scrollToBottom);
    }
  };

  return (
    <div className={classes}>
      {
        trigger
          ? (
            <button
              type="button"
              className="bttn--inline"
              onClick={(event) => triggerClick(event.target)}
            >
              { children }
            </button>
          )
          : children
      }
    </div>
  );
};

Footer.propTypes = {
  children: oneOfType([
    node,
    arrayOf(node)
  ]).isRequired,
  className: string,
  nopadding: bool,
  onTriggerClick: func,
  scrollToBottom: bool,
  triggerFor: string,
  hideTopBorder: bool
};

Footer.defaultProps = {
  className: null,
  nopadding: false,
  onTriggerClick: null,
  scrollToBottom: false,
  triggerFor: null,
  hideTopBorder: false
};

export default Footer;
